import { ApplicationIcon, Icon, Chip } from '@saviynt/design-system';
import React from 'react';
import {  formatLocalizedDateTime } from '@saviynt/common';
import CountdownTimer from '../components/CountdownTimer/CountdownTimer';

const useCreateRowObject = (row) => {
  const createIcon = (type, kind, color, size) => {
    if (type === 'account') {
      return <Icon kind='Account' color='neutral-1000' size='small' />;
    }

    return <Icon kind={kind} color={color} size={size} />;
  };

  const getObjectForCategory = (account, platform, type) => {
    const icon = createIcon(type);

    const obj = {
      account,
      platform,
      icon,
    };

    return obj;
  };

  const getObjectForTitle = (endpointName, accountName) => {
    const obj = [
      {
        kind: 'text',
        text: endpointName,
      },
      {
        kind: 'label-value',
        label: 'Account',
        value: accountName,
      },
    ];

    return obj;
  };

  const getObjectForDescription = (data) => {
    let obj = [];

    if (data.type === 'account') {
      obj = [
        {
          kind: 'text',
          text: data.accountDescription,
        },
      ];
    } else if (data.type === 'endpoint' || data.type === 'session') {
      obj = [];

      switch (data?.assetType?.toLowerCase()) {
        case 'server':
        case 'application':
        case 'database':
          obj.push({
            kind: 'icon-text',
            icon: createIcon(data.type, data.assetType, null, 'small'),
            text: data.assetType,
          });
          break;
        default:
          break;
      }

      switch (data?.platformType?.toLowerCase()) {
        case 'aws':
        case 'gcp':
        case 'azure':
        case 'okta':
        case 'ad':
        case 'sap':
          obj.push({
            kind: 'avatar-text',
            avatar: (
              <ApplicationIcon
                size='xxSmall'
                kind='logo'
                logo={data.platformType}
              />
            ),
            text: data.platformType,
          });
          break;
        default:
          break;
      }

      if (data.epCustomproperty10) {
        obj.push({
          kind: 'label-value',
          label: 'Location',
          value: data.epCustomproperty10,
        });
      }

      if (data.endpointDescription) {
        obj.push({ kind: 'text', text: data.endpointDescription });
      }
    }

    return obj;
  };

  function getTitleObjectBasedOnType() {
    if (row.type === 'session') {
      return getObjectForTitle(row.endpointName, row.accountName);
    }

    if (row.type === 'account') {
      return [{ kind: 'text', text: row.accountName }];
    }

    return [{ kind: 'text', text: row.endpointName }];
  }

  function getPrimaryIconObject() {
    if (
      row.type === 'endpoint' ||
      (row.type === 'account' && row.credentialType === 'CREDENTIAL')
    ) {
      return createIcon(null, 'PasswordCredentialUnlock', 'navy-700', 'medium');
    }

    if (row.type === 'session') {
      return createIcon(null, 'SubtractCircle', 'critical-700', 'medium');
    }

    return null;
  }

 function getStatusObjectBasedOnType(row) {
    
      if (row?.type?.toLowerCase() === 'session') {
        if (new Date(row?.sessionStartDate).getTime() > new Date().getTime()) {
          
          return (
            <Chip
              kind='subtleFilled'
              color='brandSecondary'
              label={formatLocalizedDateTime(row?.sessionStartDate)}
              leftIcon={<Icon kind='Calendar' size='medium' />}
            />
          )
        }

        return (
          <Chip
            kind='subtleFilled'
            color='brandSecondary'
            label={
              (<CountdownTimer
                targetDate={row?.sessionEndDate}
                leftText='&nbsp;left'
                item={row}
              />)
            }
            leftIcon={<Icon kind='Time' size='medium' />}
          />
        );
      }

      return null;
    
  }


  const createObjectForRow = () => {
    const rowObject = {
      category:
        row.type === 'account'
          ? getObjectForCategory(row.accountName, row.platformType, row.type)
          : null,
      title: getTitleObjectBasedOnType(),
      description: getObjectForDescription(row),

      status: getStatusObjectBasedOnType(row),

      primaryIcon: getPrimaryIconObject(),
      secondaryIcon:
        row.type === 'endpoint' ||
        (row.type === 'account' && row.credentialType === 'CREDENTIALLESS')
          ? createIcon(null, 'ConnectPlug', 'navy-700', 'medium')
          : null,
      hasMoreOptions: row.type === 'session',
      type: row.type,
    };

    return rowObject;
  };

  return createObjectForRow;
};

export default useCreateRowObject;
